import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('block-slider', {
    props: {
        customClassBlockSlider: {
            type: String,
            required: false,
        },
        data: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            swiper: null,
        };
    },

    async mounted() {
        window.addEventListener('resize', this.setScrollbarLeftSizeOffset);
        this.timeout = setTimeout(async () => {
            await this.initSwiper();
            this.setScrollbarLeftSizeOffset();
        }, 400);
        this.intersect();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.setScrollbarLeftSizeOffset);
    },

    methods: {
        async initSwiper() {
            const slider = this.$el.querySelector(
                this.customClassBlockSlider ?? '.block-slider__slider',
            );

            if (!slider) {
                return;
            }

            const { Swiper } = await getSwiper();
            const { Scrollbar, Navigation, Pagination } =
                await getSwiperModules();

            this.swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                centeredSlides: true,
                observer: true,
                observeParents: true,
                modules: [Scrollbar, Navigation, Pagination],
                scrollbar: {
                    el: slider.querySelector('.swiper-scrollbar'),
                    hide: false,
                    draggable: true,
                },
                uniqueNavElements: true,
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                },
            }).on('slideChange', (swiper) => {
                this.setScrollbarLeftSizeOffset();
            });
            this.swiper.on('transitionStart', () => {
                const allVideos = this.$el.querySelectorAll(
                    '.swiper-slide video',
                );
                if (!allVideos.length > 0) {
                    return;
                }

                allVideos.forEach((element) => {
                    element.pause();
                    element.currentTime = 0;
                });
            });

            this.swiper.on('transitionEnd', () => {
                if (
                    this.$el.querySelectorAll('.swiper-slide-active video')
                        .length > 0
                ) {
                    this.$el.querySelectorAll(
                        '.swiper-slide-active video',
                    )[0].currentTime = 0;
                    this.$el
                        .querySelectorAll('.swiper-slide-active video')[0]
                        .play();
                }
            });
        },

        intersect() {
            var options = {
                rootMargin: '300px',
                threshold: 0,
            };
            var videoSlider = this.$el.querySelector(
                this.customClassBlockSlider ?? '.block-slider__slider',
            );
            var observer = new IntersectionObserver((entries, observer) => {
                var isIntersecting =
                    typeof entries[0].isIntersecting === 'boolean'
                        ? entries[0].isIntersecting
                        : entries[0].intersectionRatio > 0;
                if (isIntersecting) {
                    this.autoplayVideo();
                    observer.unobserve(videoSlider);
                }
            }, options);
            observer.observe(videoSlider);
        },

        autoplayVideo() {
            const firstVideo = this.$el.querySelector(
                '.swiper-slide-active video',
            );
            if (firstVideo) {
                firstVideo.play();
            }

            const allVideos = this.$el.querySelectorAll('.swiper-slide video');
            allVideos.forEach((element) => {
                element.addEventListener('ended', this.nextSlide);
            });
        },

        nextSlide() {
            this.swiper.slideNext();
        },

        destroySwiper() {
            this.swiper.destroy();
            this.swiper = null;
        },

        setScrollbarLeftSizeOffset() {
            if (!this.isDarkVariant) return;

            const element = document.querySelector(
                '.block-slider__wrapper.swiper-container',
            );
            const scrollBar = document.querySelector('.swiper-scrollbar');
            if (!element || !scrollBar) return;

            const leftOffset = element.getBoundingClientRect().left - 30; // 30px is the padding of the container
            scrollBar.style.left = `${leftOffset}px`;
        },
    },
});
